import createIcon from '../../createIcon';

/**
 * @component @name Favorite
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMjEuMTc1TDEwLjU1IDE5Ljg1NUM1LjQgMTUuMTg1IDIgMTIuMTA1IDIgOC4zMjQ5NUMyIDUuMjQ0OTUgNC40MiAyLjgyNDk1IDcuNSAyLjgyNDk1QzkuMjQgMi44MjQ5NSAxMC45MSAzLjYzNDk1IDEyIDQuOTE0OTVDMTMuMDkgMy42MzQ5NSAxNC43NiAyLjgyNDk1IDE2LjUgMi44MjQ5NUMxOS41OCAyLjgyNDk1IDIyIDUuMjQ0OTUgMjIgOC4zMjQ5NUMyMiAxMi4xMDUgMTguNiAxNS4xODUgMTMuNDUgMTkuODY1TDEyIDIxLjE3NVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Favorite = createIcon('Favorite', [
  [
    'path',
    {
      d: 'M12 21.175L10.55 19.855C5.4 15.185 2 12.105 2 8.32495C2 5.24495 4.42 2.82495 7.5 2.82495C9.24 2.82495 10.91 3.63495 12 4.91495C13.09 3.63495 14.76 2.82495 16.5 2.82495C19.58 2.82495 22 5.24495 22 8.32495C22 12.105 18.6 15.185 13.45 19.865L12 21.175Z',
      key: '1hbla3',
    },
  ],
]);

export default Favorite;
